// extracted by mini-css-extract-plugin
module.exports = {"Payment":"Payment_Payment__Sv9xx"};